/* 47X · ENTREGA ESTIMADA · calculador de días hábiles · ES5
   ─────────────────────────────────────────────────────────────────────────
   UNA sola fuente para toda la tienda. Los plazos y los festivos viven en
   los ajustes del tema; aquí solo se calcula.

   Sin librerías, sin peticiones, sin API externa. Se calcula UNA vez por
   carga y el resultado se reparte a todos los elementos de la página.

   Días hábiles = lunes a viernes, descontando festivos oficiales de México.
   Si el cliente entra sábado, domingo o festivo, el conteo arranca el
   siguiente día hábil: prometer desde un día que nadie trabaja sería mentir.

   Zona horaria fija America/Mexico_City. Sin esto, alguien entrando a las
   11 de la noche desde otro huso vería un día distinto al real de la bodega.

   30-oct-2026 · calcula() acepta (min, max) opcionales para poder pedir un
   plazo distinto al oficial —el del pedido prioritario— SIN duplicar en otro
   archivo la lógica de días hábiles ni la lista de festivos. Sin argumentos
   se comporta exactamente igual que antes y sigue usando la caché.
*/
(function () {
  'use strict';
  if (window.De47) return;

  var MESES = ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC'];

  function cfg() {
    try {
      var n = document.querySelector('[data-de47-cfg]');
      return n ? JSON.parse(n.textContent) : null;
    } catch (e) { return null; }
  }

  /* Hoy, según el reloj de la Ciudad de México, no el del visitante */
  function hoyMx() {
    try {
      var f = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit'
      });
      var p = f.format(new Date()).split('-');
      return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    } catch (e) {
      var d = new Date();
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
  }

  function lunesN(y, mes, n) {
    var primero = new Date(y, mes, 1);
    var dia = 1 + ((8 - primero.getDay()) % 7);
    if (primero.getDay() === 1) dia = 1;
    return new Date(y, mes, dia + (n - 1) * 7);
  }

  function clave(d) {
    var m = d.getMonth() + 1, dd = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (dd < 10 ? '0' + dd : dd);
  }

  /* Festivos federales mexicanos que se pueden calcular solos, año por año.
     Los que cambian por decreto van en la lista editable del tema. */
  function festivos(y) {
    var f = {};
    function pon(d) { f[clave(d)] = 1; }
    pon(new Date(y, 0, 1));        /* Año Nuevo */
    pon(lunesN(y, 1, 1));          /* Constitución · 1er lunes de febrero */
    pon(lunesN(y, 2, 3));          /* Natalicio de Juárez · 3er lunes de marzo */
    pon(new Date(y, 4, 1));        /* Día del Trabajo */
    pon(new Date(y, 8, 16));       /* Independencia */
    pon(lunesN(y, 10, 3));         /* Revolución · 3er lunes de noviembre */
    pon(new Date(y, 11, 25));      /* Navidad */
    /* Transmisión del Poder Ejecutivo: cada 6 años, 1 de octubre */
    if ((y - 2024) % 6 === 0) pon(new Date(y, 9, 1));
    return f;
  }

  function calcula(mArg, xArg) {
    var c = cfg();
    if (!c) return null;

    /* sin argumentos manda el plazo oficial del tema; con ellos, el que pidan */
    var nMin = (mArg === undefined || mArg === null) ? c.min : mArg;
    var nMax = (xArg === undefined || xArg === null) ? c.max : xArg;

    var extra = {};
    var lista = (c.festivos || '').split(',');
    for (var i = 0; i < lista.length; i++) {
      var s = lista[i].replace(/\s+/g, '');
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) extra[s] = 1;
    }

    var base = hoyMx();
    var anios = {};
    function esFestivo(d) {
      var y = d.getFullYear();
      if (!anios[y]) anios[y] = festivos(y);
      var k = clave(d);
      return !!(anios[y][k] || extra[k]);
    }
    function esHabil(d) {
      var dw = d.getDay();
      return dw >= 1 && dw <= 5 && !esFestivo(d);
    }

    /* Si hoy no se trabaja, el conteo arranca el siguiente día que sí */
    var arranque = new Date(base.getTime());
    var tope = 0;
    while (!esHabil(arranque) && tope < 30) {
      arranque.setDate(arranque.getDate() + 1); tope++;
    }

    function suma(n) {
      var d = new Date(arranque.getTime()), contados = 0, giros = 0;
      while (contados < n && giros < 400) {
        d.setDate(d.getDate() + 1); giros++;
        if (esHabil(d)) contados++;
      }
      return d;
    }

    var min = suma(nMin), max = suma(nMax);
    function fmt(d) { return d.getDate() + ' ' + MESES[d.getMonth()]; }

    return {
      min: min, max: max,
      rango: fmt(min) + ' — ' + fmt(max),
      /* El plazo oficial es un RANGO: "de 6 a 15 días
         hábiles". El rango de FECHAS de arriba sigue siendo rango,
         porque puede llegar antes; lo que no se promete es un piso. */
      dias: 'de ' + nMin + ' a ' + nMax + ' días hábiles',
      iso_min: clave(min), iso_max: clave(max),
      empiezaHoy: clave(arranque) === clave(base)
    };
  }

  var res = null;
  function pinta() {
    if (!res) res = calcula();
    if (!res) return;

    var rangos = document.querySelectorAll('[data-de47-rango]');
    for (var i = 0; i < rangos.length; i++) rangos[i].textContent = res.rango;

    var dias = document.querySelectorAll('[data-de47-dias]');
    for (var j = 0; j < dias.length; j++) dias[j].textContent = res.dias;

    /* variante de una línea, para la barra de confianza y el carrito */
    var cortos = document.querySelectorAll('[data-de47-corto]');
    for (var k = 0; k < cortos.length; k++) cortos[k].textContent = res.rango;

    var cajas = document.querySelectorAll('[data-de47]');
    for (var m = 0; m < cajas.length; m++) cajas[m].hidden = false;
    pasos();
  }

  /* ── pasos · una sola línea de texto, sin acordeón ni popup ─────────
     Al soltar el paso vuelve la nota general: así el bloque nunca se queda
     mostrando algo que el cliente ya no está señalando. */
  function pasos() {
    var hints = document.querySelectorAll('[data-de47-hint]');
    if (!hints.length) return;
    var base = [];
    for (var h = 0; h < hints.length; h++) base.push(hints[h].textContent);

    function muestra(caja, txt) {
      /* Un paso sin texto no dice nada: se queda la nota general en vez de
         dejar el renglón en blanco. */
      if (txt === '' || txt === null) return;
      var hint = caja.querySelector('[data-de47-hint]');
      if (!hint || hint.textContent === txt) return;
      hint.classList.add('is-cambio');
      hint.textContent = txt;
      setTimeout(function () { hint.classList.remove('is-cambio'); }, 140);
    }

    document.addEventListener('pointerover', function (e) {
      var b = e.target.closest ? e.target.closest('[data-de47-paso]') : null;
      if (!b) return;
      var caja = b.closest('[data-de47]');
      if (caja) muestra(caja, b.getAttribute('data-de47-paso'));
    });

    document.addEventListener('pointerout', function (e) {
      var b = e.target.closest ? e.target.closest('[data-de47-paso]') : null;
      if (!b) return;
      var caja = b.closest('[data-de47]');
      if (!caja || caja.querySelector('.de47__paso.is-on')) return;
      var hint = caja.querySelector('[data-de47-hint]');
      var i = Array.prototype.indexOf.call(hints, hint);
      if (hint && i > -1) muestra(caja, base[i]);
    });

    /* en táctil el hover no existe: el tap fija el paso y el segundo lo suelta */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-de47-paso]') : null;
      if (!b) return;
      e.preventDefault();
      var caja = b.closest('[data-de47]');
      if (!caja) return;
      var ya = b.classList.contains('is-on');
      var todos = caja.querySelectorAll('[data-de47-paso]');
      for (var i = 0; i < todos.length; i++) todos[i].classList.remove('is-on');
      var hint = caja.querySelector('[data-de47-hint]');
      var k = Array.prototype.indexOf.call(hints, hint);
      if (ya) { if (k > -1) muestra(caja, base[k]); }
      else { b.classList.add('is-on'); muestra(caja, b.getAttribute('data-de47-paso')); }
    });
  }

  window.De47 = {
    calcula: function (m, x) {
      if (m !== undefined || x !== undefined) return calcula(m, x);
      if (!res) res = calcula();
      return res;
    },
    pinta: pinta
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinta);
  } else { pinta(); }
})();
